import React from 'react';
import { Outlet } from 'react-router-dom';
import Card from 'components/Card';
import Steps from '../../../components/Steps';

import './style.scss';

const Phone: React.FC = () => {
    return (
        <Card form>
            <h2>{__('手机号修改')}</h2>
            <div className="modify-phone-root">
                <Steps type="modifyPhone" />
                <Outlet />
            </div>
        </Card>
    );
};

export default Phone;
